import { atom } from "recoil";

export const tgBotsAddModalStore = atom({
	key: "tgBotsAddModalStore",
	default: {
		show: false,
		loaded: true,
		bot_link: "",
		priority: "",
		token: "",
	},
});
